__turbopack_context__.v({
  "className": "v3HjAa_className",
  "variable": "v3HjAa_variable",
});
